import {
  $notificationsTableSearchInputValue,
  NotificationsTable,
  NotificationsTableGate,
  notificationsTableQuery,
  notificationsTableSearchChanged,
} from '@/entities/notifications'
import { ROUTES, STRINGS } from '@/shared/config'
import {
  ContentWrapper,
  EmptyContent,
  HeaderContent,
  HidingSpin,
} from '@/shared/ui'
import { PrimaryButton } from '@/shared/ui'
import { PlusOutlined, SearchOutlined } from '@ant-design/icons'
import { Flex, Input, Space, Typography } from 'antd'
import { useUnit } from 'effector-react'
import { NavLink, useNavigate } from 'react-router-dom'

import { notificationViewModalOpened } from './model/notification-view-modal.model'
import {
  $notificationsListPageLatestFilters,
  $notificationsListPageLatestPage,
  $notificationsListPageLatestPageSize,
  $notificationsListPageLatestSearch,
  $notificationsListPageLatestSort,
  NotificationsListPageGate,
} from './model/notifications-list.model'
import { NotificationViewModal } from './ui/NotificationViewModal'

export function NotificationsListPage() {
  const { data, pending, error } = useUnit(notificationsTableQuery)
  const search = useUnit($notificationsTableSearchInputValue)
  const changeSearch = useUnit(notificationsTableSearchChanged)
  const latestSearch = useUnit($notificationsListPageLatestSearch)
  const latestSort = useUnit($notificationsListPageLatestSort)
  const latestFilters = useUnit($notificationsListPageLatestFilters)
  const latestPage = useUnit($notificationsListPageLatestPage)
  const latestPageSize = useUnit($notificationsListPageLatestPageSize)
  const navigate = useNavigate()
  const openViewModal = useUnit(notificationViewModalOpened)
  return (
    <>
      <NotificationsListPageGate />
      <NotificationsTableGate
        initialFilters={latestFilters}
        initialPage={latestPage}
        initialPageSize={latestPageSize}
        initialSort={latestSort}
        initialSearch={latestSearch}
        polling
      />
      <NotificationViewModal />
      <HeaderContent
        title="Push уведомления"
        description="Здесь можно создавать и редактировать push-уведомления для пользователей."
        buttonSlot={
          <NavLink to={ROUTES.SETTINGS.CREATE_NOTIFICATION}>
            <PrimaryButton icon={<PlusOutlined />}>Создать</PrimaryButton>
          </NavLink>
        }
      />

      <ContentWrapper>
        <Flex
          justify="space-between"
          align="center"
          style={{ marginBottom: 24 }}
        >
          <Typography.Text style={{ fontWeight: 600 }}>
            Список шаблонов
          </Typography.Text>
          <Space>
            <Input
              placeholder={STRINGS.placeholder_search_by_name_input}
              allowClear
              addonAfter={<SearchOutlined />}
              value={search || ''}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                const searchString = event.target.value
                changeSearch(searchString)
              }}
              style={{
                minWidth: 300,
              }}
            />
          </Space>
        </Flex>
        <HidingSpin spinning={pending || (!data?.items && !error)}>
          {data?.items && data.items.length > 0 ? (
            <NotificationsTable
              onEdit={(notificationId: string) => {
                void navigate(
                  ROUTES.SETTINGS.EDIT_NOTIFICATION.replace(
                    ':id',
                    notificationId,
                  ),
                )
              }}
              onView={(notificationId: string) => {
                openViewModal({ id: notificationId })
              }}
            />
          ) : search?.length && search?.length > 0 ? (
            <EmptyContent description={STRINGS.nothing_was_found} />
          ) : (
            <EmptyContent description="В списке пока нет ни одного шаблона" />
          )}
        </HidingSpin>
      </ContentWrapper>
    </>
  )
}
